/**
 * Employee dashboard — cash, fuel/non-fuel totals, tanks, credit outstanding, graphs.
 * Loads /api/dashboard (and related totals); requires operational date meta when applicable.
 */
import React, { Component, useRef, useState, useEffect } from "react";
import inhand from '../../../img/inhand.png'
import store from '../../../img/store.png'
import money from '../../../img/money.png'
import fuelstation from '../../../img/fuel-banner.png'
import { Link, useLocation } from "react-router-dom";
import { API_URL } from '../../../constant/API_Settings'
import { WEB_URL } from "../../../constant/API_Settings"
import BankModal from "react-modal";
import LoginHeaderOperational from '../LoginHeaderOperational';
import ReactTooltip from 'react-tooltip'
import DashBoardModal from './DashBoardModal.component'
import { DateRangePicker } from "materialui-daterange-picker";
import moment from 'moment';





import ReactDOM from 'react-dom';
import Loader from "./Loader.component"
import { useHistory } from 'react-router-dom';
import Sidebar_Progress from "../../layouts/Operational_Sidebar_Progress.component";
import { applyCheckUrlNavigation } from "../../../utils/checkUrlNavigation";
import { clearAuthStorage, getValidAuthToken } from "../../../utils/authToken";
import { FuelLabel, getFuelLabelClass } from "../../../utils/fuelLabelColor";
import FuelStockChart from "./FuelStockChart.component";
import FuelDetailModal from "./FuelDetailModal.component";
import EmployeeSalesTrendChart from "./EmployeeSalesTrendChart";
import EmployeeFuelPriceTrendChart from "./EmployeeFuelPriceTrendChart";
import "./employee-dashboard.css";

const TankModal = (props) => ReactDOM.createPortal(
  <DashBoardModal {...props} />, document.body
);

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatLitres = (value) =>
  `${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} L`;

const getCurrentMonthRange = () => ({
  start: moment().startOf("month").format("DD-MM-YYYY"),
  end: moment().format("DD-MM-YYYY"),
});

const DashBoard = (props, progress) => {
  // -------------------------------------------------------------------------
  // State — widgets, date range filters, permissions, loading gate
  // -------------------------------------------------------------------------
  const location_details = useLocation()
  const [graph, setGraph] = useState([])
  const [color, setColor] = useState([])
  const [purchaseGraph, setPurchaseGraph] = useState([])
  const [purchaseGraphDetails, setPurchaseGraphDetails] = useState([])
  const history = useHistory()
  const [permission, setPermission] = useState([])
  const [graph_details, setGraphDetails] = useState([])
  const [cash, setCash] = useState([])
  const [fuel_data, setFuel] = useState([])
  const [fueldata, setFuelDetails] = useState([])
  const [tank_data, setTank] = useState([])
  const [Bank_data, setBank] = useState({ data: [], outstanding: "0.00" })
  const [dealer_statement, setdealer_statement] = useState([])
  const [tankdata, setTankDetails] = useState([])
  const [cash_approval, setCashApproval] = useState([])
  const [bank_approval, setBankApproval] = useState([])
  const [total_cash, setTotalCash] = useState([])
  const [total_fuelsales, settotal_fuel] = useState([])
  const [total_nonfuelsales, settotal_nonfuel] = useState([])
  const [total_expenses, settotal_expenses] = useState([])
  const [total_cylinder, settotal_cylinder] = useState([])
  const [critical_stock, setCriticalStock] = useState([])
  const [custm_outstanding, setOutStanding] = useState([])
  const [id, setId] = useState([])
  const defaultSalesRange = getCurrentMonthRange();
  const [datestart, setdatestart] = useState(defaultSalesRange.start)
  const [datestartexp, setdatestartexp] = useState([])
  const [dateend, setdateend] = useState(defaultSalesRange.end)
  const [dateendexp, setdateendexp] = useState([])
  const [dashboardReady, setDashboardReady] = useState(false);
  const [salesPeriodLabel, setSalesPeriodLabel] = useState(
    `Current month ${defaultSalesRange.start} → ${defaultSalesRange.end}`
  );
  const [selectedDate, setSelectedDate] = useState(localStorage.getItem("m_op_date") || '');
  const [creditSummary, setCreditSummary] = useState({
    summary: {},
    top_customers: [],
    overdue_customers: [],
    as_of_date: "",
  });
  const [priceTrendFilter, setPriceTrendFilter] = useState('daily');
  const [fuelPriceTrendData, setFuelPriceTrendData] = useState([]);
  const [fuelPriceTrendSeries, setFuelPriceTrendSeries] = useState([]);
  const [priceTrendLoading, setPriceTrendLoading] = useState(false);
  const [salesTrendRange, setSalesTrendRange] = useState('30');
  const [purchaseTrendRange, setPurchaseTrendRange] = useState('30');
  const authFailureHandledRef = useRef(false);

  const parseJsonResponse = async (response) => {
    if (response.status === 401 || response.status === 403) {
      const authError = new Error("AUTH_UNAUTHORIZED");
      authError.code = "AUTH_UNAUTHORIZED";
      throw authError;
    }
    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) {
      throw new Error("API did not return JSON (unauthenticated or server error).");
    }
    const payload = await response.json();
    if (!response.ok) {
      const apiError = new Error(payload?.message || `API request failed (${response.status})`);
      apiError.code = "API_HTTP_ERROR";
      apiError.status = response.status;
      throw apiError;
    }
    return payload;
  };

  const redirectToLogin = () => {
    if (authFailureHandledRef.current) {
      return;
    }
    authFailureHandledRef.current = true;
    clearAuthStorage();
    history.push("/login");
  };

  const handleDashboardFetchError = (label, error) => {
    if (error?.code === "AUTH_UNAUTHORIZED" || error?.message === "AUTH_UNAUTHORIZED") {
      redirectToLogin();
      return;
    }
    if (error?.message?.includes("API did not return JSON")) {
      // Avoid noisy duplicate logs when backend returns HTML/login page.
      return;
    }
    console.error(`[Dashboard] ${label} failed`, error);
  };
  const [page, setpages] = useState(
    {

    })
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      document.body.classList.remove("emp-fuel-modal-open");
      return undefined;
    }

    document.body.classList.add("emp-fuel-modal-open");
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.classList.remove("emp-fuel-modal-open");
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen]);

  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

const toggledate = () => {
  setOpen(!open);
};

const toggledateexp = () => {
  // alert(3)
  setOpen1(!open1);
};


const setDateRange = (date) => {

  let datestart = moment((date.startDate)).format("DD-MM-YYYY")
   setdatestart(datestart)

  let dateend = moment((date.endDate)).format("DD-MM-YYYY")
  setdateend(dateend)

  if(datestart && dateend){
 
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        pathurl: window.location.pathname,
        datestart:datestart,
        dateend:dateend,
      }),
    };
    fetch(`${API_URL}/totalsales`, requestOptions)
    .then(response => { return response.json(); })
    .then(responseData => {
     
   const payload = responseData.data || {};
   settotal_fuel(payload);
   settotal_nonfuel(payload);
   setSalesPeriodLabel(
     payload.period_label
       ? `${payload.period_label} ${payload.period_from || datestart} → ${payload.period_to || dateend}`
       : `Custom range ${datestart} → ${dateend}`
   );

    })

      .catch(e => {
        console.error("[Dashboard] totalsales range fetch failed", e);
      });
    toggledate()
  }

};

const setDateRangeexp = (date) => {

  let datestartex = moment((date.startDate)).format("DD-MM-YYYY")
   setdatestartexp(datestartex)

  let dateendex = moment((date.endDate)).format("DD-MM-YYYY")
  setdateendexp(dateendex)

  if(datestartex && dateendex){
 
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        pathurl: window.location.pathname,
        datestart:datestartex,
        dateend:dateendex,
      }),
    };
    fetch(`${API_URL}/totalexpense`, requestOptions)
    .then(response => { return response.json(); })
    .then(responseData => {
     
  
      let tot_exp=responseData.data.exp_data
      settotal_expenses(tot_exp || []);
    })

      .catch(e => {
        console.error("[Dashboard] totalexpense range fetch failed", e);
      });
    toggledateexp()
  }

};
////endexp///
function toggleModal() {
    setIsOpen(false);
}

const handleDateChange = (date) => {
};

  function toggleModal1() {
    setIsOpen1(!isOpen1);
  }

  const [isClose, setIsClose] = useState(false);
  function toggle() {
    setIsClose(!isClose);

  }
  const [isClose1, setIsClose1] = useState(false);
 
  const data = [
    {
      name: "Page A",
      uv: 100,
      pv: 60,
      pp: 60

    },
    {
      name: "Page B",
      uv: 50,
      pv: 30

    },
    {
      name: "Page C",
      uv: 40,
      pv: 20,
      pp: 50
    },
    {
      name: "Page D",
      uv: 50,
      pv: 0,
      pp: 23
    },
    {
      name: "Page E",
      uv: 20,
      pv: 0,
      pp: 60

    },
    {
      name: "Page F",
      uv: 10,
      pv: 30,
      pp: 23
    },
    {
      name: "Page G",
      uv: 50,
      pv: 30,
      pp: 23
    }
  ];

  //---On Load---//

  useEffect(() => {
    if (!getValidAuthToken()) {
      redirectToLogin();
      return;
    }
    setpages(data);
    check_url();
    total_fuel();
    total_expense();
    check_meta_date();
    total_cylinderstock();
    ListDashBoardItem();
  }, []);

  useEffect(() => {
    Credit_cust(selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    fetchFuelPriceTrend(priceTrendFilter);
  }, [priceTrendFilter]);

  /** Route permission check — navigate only when target path differs (avoids /dashboard remount loop). */
  function check_url() {
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        pathurl: window.location.pathname,
      }),
    };
    fetch(`${API_URL}/check_url`, requestOptions)
      .then((response) => parseJsonResponse(response))
      .then(responseData => {
        applyCheckUrlNavigation(
          history,
          responseData,
          window.location.pathname,
          () => {}
        );

        if (Number(responseData?.allowurl) !== 1) {
          setPermission({
            status: 3,
            message: "You do not have permission to view this page.",
          });
        }

        return responseData;
      })
      .catch(e => {
        console.error("[Dashboard] check_url failed", e);
      });

  }

  function total_fuel(fromDate = datestart, toDate = dateend) {
    const rangeStart = fromDate || getCurrentMonthRange().start;
    const rangeEnd = toDate || getCurrentMonthRange().end;
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        pathurl: window.location.pathname,
        datestart: rangeStart,
        dateend: rangeEnd,
      }),
    };
    fetch(`${API_URL}/totalsales`, requestOptions)
    .then((response) => parseJsonResponse(response))
    .then(responseData => {
   const payload = responseData.data || {};
   settotal_fuel(payload);
   settotal_nonfuel(payload);
   if (payload.period_label) {
     const from = payload.period_from ? ` ${payload.period_from}` : "";
     const to = payload.period_to ? ` → ${payload.period_to}` : "";
     setSalesPeriodLabel(`${payload.period_label}${from}${to}`);
   } else {
     setSalesPeriodLabel(`Current month ${rangeStart} → ${rangeEnd}`);
   }
    })
      .catch((e) => handleDashboardFetchError("totalsales fetch", e));
    
  }


  const handleDateChanges = (e) => {
    const { value } = e.target;
    setSelectedDate(value);
    localStorage.setItem("m_op_date", value); // Optionally store the new date in localStorage
    Credit_cust(value);
  };

  function Credit_cust(date) {
    const requestOptions = {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      },
      body: JSON.stringify({
        selectedDate: date || undefined,
        limit: 10,
      })
    };
    fetch(API_URL + "/custcredit", requestOptions)
      .then((response) => parseJsonResponse(response))
      .then(responseData => {
        const payload = responseData?.data || {};
        setCreditSummary({
          summary: payload.summary || {},
          top_customers: payload.top_customers || [],
          overdue_customers: payload.overdue_customers || [],
          as_of_date: payload.as_of_date || "",
        });
      })
      .catch(e => {
        setCreditSummary({
          summary: {},
          top_customers: [],
          overdue_customers: [],
          as_of_date: "",
        });
        handleDashboardFetchError("credit customer fetch", e);
      });
  }

  function total_expense() {
    // alert(22)
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        pathurl: window.location.pathname,
      }),
    };
    fetch(`${API_URL}/totalexpense`, requestOptions)
    .then((response) => parseJsonResponse(response))
    .then(responseData => {
      let tot_exp=responseData.data.exp_data
      settotal_expenses(tot_exp || []);
    })
      .catch((e) => handleDashboardFetchError("totalexpense fetch", e));
    
  }

  function fetchFuelPriceTrend(filter = 'daily') {
    setPriceTrendLoading(true);
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({ filter }),
    };
    fetch(`${API_URL}/dashboard-fuel-price-trend`, requestOptions)
      .then((response) => parseJsonResponse(response))
      .then((responseData) => {
        setFuelPriceTrendData(responseData.data || []);
        setFuelPriceTrendSeries(responseData.series || []);
      })
      .catch((e) => {
        handleDashboardFetchError("fuel price trend fetch", e);
        setFuelPriceTrendData([]);
        setFuelPriceTrendSeries([]);
      })
      .finally(() => setPriceTrendLoading(false));
  }

  function total_cylinderstock() {
    // alert(22)
    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        pathurl: window.location.pathname,
      }),
    };
    fetch(`${API_URL}/totalcylinderstock`, requestOptions)
    .then((response) => parseJsonResponse(response))
    .then(responseData => {
      let tot_cyl=responseData.data.tot_cyl
      settotal_cylinder(tot_cyl || []);
    })
      .catch((e) => handleDashboardFetchError("totalcylinderstock fetch", e));
    
  }
  // console.log(total_fuelsales.mindate,"xxxxxxxxxxxxxxxxxxxxxx")
  function handleFuelDetails(obj) {
    setOpen(false);
    setOpen1(false);
    setFuelDetails(obj.fuel_details);
    setIsOpen(true);
  }
  // function bankddddddddd() {

  //   //  setFuelDetails(obj.fuel_details)

  //   toggleModal1()
  //   alert("nnnnnnnnnnnnnnn")
    
  // }
  function handleTankDetails(obj) {
    setTankDetails(obj)
    toggle()

  }

  function handleBankDetails() {
    toggle();
  }
  const check_meta_date = () => {

    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      }
    };
    fetch(`${API_URL}/check_meta_date`, requestOptions)
      .then((response) => parseJsonResponse(response))
      .then(responseData => {
        setId(responseData.userId);
        if (responseData.op_date) {
          localStorage.setItem("m_op_date", responseData.op_date);
          setSelectedDate((prev) =>
            prev === responseData.op_date ? prev : responseData.op_date
          );
        }
        return responseData;
      })
      .catch(e => {
      });

  }

  //-------------------Dashboard List Item ---(akhitha-20/7/2021)----------//
  /**
   * Main dashboard payload: cash, fuel, NF critical stock, credit customers, graphs.
   * 10s timeout; rejects HTML login redirect so loader always clears.
   */
  function ListDashBoardItem() {
    const token = getValidAuthToken();
    if (!token) {
      redirectToLogin();
      return;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 120000);

    const requestOptions = {
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
      signal: controller.signal,
    };

    fetch(`${API_URL}/dashboard`, requestOptions)
      .then((response) => parseJsonResponse(response))
      .then((responseData) => {
        if (responseData?.message === "Unauthenticated.") {
          const authError = new Error("AUTH_UNAUTHORIZED");
          authError.code = "AUTH_UNAUTHORIZED";
          throw authError;
        }
        if (responseData?.status == 3) {
          setPermission({
            ...permission,
            status: responseData.status,
            message: responseData.message,
          });
        }

        const cashInHand = responseData.cash_in_hand || {};
        const cashAtBank = responseData.cash_at_bank || {};

        setCash({
          ...cash,
          cash_in_hand: responseData.cash_hand ?? "0.00",
          cash_in_bank: responseData.cash_bank ?? "0.00",
          total_cash: responseData.total_cash_available ?? "0.00",
        });
        setCashApproval({
          ...cash_approval,
          cash_in_hand_after_approval:
            cashInHand.cash_in_hand_after_approval ?? "0.00",
          cash_in_hand_before_approval:
            cashInHand.cash_in_hand_before_approval ?? "0.00",
        });
        setBankApproval({
          ...bank_approval,
          cash_at_bank_after_approval:
            cashAtBank.cash_at_bank_after_apr ?? "0.00",
          cash_at_bank_before_approval:
            cashAtBank.cash_at_bank_before_apr ?? "0.00",
        });
        setTotalCash(responseData.total_cash || {});
        setCriticalStock(responseData.critical_non_fuel_stock || []);
        setOutStanding(responseData.Customer_outstanding || []);
        setFuel(responseData.fuelData || []);
        setTank(responseData.tankData || []);
        setBank(responseData.Bank_outstanding || { data: [], outstanding: "0.00" });

        const dealerRow = responseData.outstanding_dealer?.[0];
        if (dealerRow) {
          setdealer_statement({
            ...dealer_statement,
            crtamount: dealerRow.crtamount,
            drtamount: dealerRow.drtamount,
            total_outstnd: dealerRow.drtamount - dealerRow.crtamount,
          });
        }

        setGraphDetails(responseData.graph_data_fuels || []);
        var colors = [
          "#033E3E",
          "#fca374",
          "#8dc5a6",
          "#800000",
          "#8026f1",
          "#FFA500",
          "#808000",
          "#8dc5a6",
          "#C11B17",
          "#810541",
        ];
        setColor(colors);
        setGraph(responseData.graph_data);
        setPurchaseGraph(responseData.purchase_graph_data || []);
        setPurchaseGraphDetails(responseData.purchase_graph_data_fuels || []);
        return responseData;
      })
      .catch((e) => {
        if (e?.code === "AUTH_UNAUTHORIZED" || e?.message === "AUTH_UNAUTHORIZED") {
          redirectToLogin();
          return;
        }
        if (e?.name === "AbortError") {
          setPermission({
            status: 3,
            message:
              "Dashboard is taking too long to load. Please try again in a moment.",
          });
          return;
        }
        if (e?.code === "API_HTTP_ERROR" && e?.status === 500) {
          setPermission({
            status: 3,
            message:
              "Dashboard server error. Please pull the latest backend update or contact support.",
          });
          return;
        }
        console.error("[Dashboard] primary data fetch failed", e);
        setPermission({
          status: 3,
          message:
            "Unable to load dashboard data. Please login again and try.",
        });
      })
      .finally(() => {
        clearTimeout(timeoutId);
        setDashboardReady(true);
      });
  }
  const thStyle = {
    position: 'sticky',
    top: '0',
    background: '#c7c7c7', // or any other background color
    zIndex: 1,
    padding: '8px',
    border: '1px solid #ddd',
    boxShadow: '0 2px 2px -1px rgba(0, 0, 0, 0.4)'
  };

  const nonFuelTotal = (total_nonfuelsales?.nonfueldata || []).reduce(
    (sum, obj) => sum + (Number(obj.amt) > 0 ? Number(obj.amt) : 0),
    0
  );

  const creditStats = creditSummary.summary || {};
  const topCreditCustomers = creditSummary.top_customers || [];

  // -------------------------------------------------------------------------
  // Render — summary cards, charts, credit table, tank/bank modals
  // -------------------------------------------------------------------------
  return (
    <>
      <div className="main-container page-wrap">
        <div className="d-md-flex">
          <Sidebar_Progress props={props} progress={22} />
          <div className="content-area ">
            <LoginHeaderOperational props={props} page_title="" />
            <div className="container pb-3">

            {permission.status==3 ?
										<div  className="form-wrap mt-5">
											<div className="text-center">
											{permission.message}
											</div></div>:
              <div className={`emp-dashboard mt-md-4 mt-3${isOpen ? " emp-dashboard--modal-open" : ""}`}>
                {!dashboardReady ? <Loader /> : null}
                <div className={`emp-dashboard__loading-overlay ${!dashboardReady ? "is-loading" : ""}`}>
                  <div className="emp-dashboard__header">
                    <h1 className="emp-dashboard__title">Dashboard</h1>
                    <p className="emp-dashboard__subtitle">
                      Cash position, fuel stock, sales summary, and daily operations at a glance.
                    </p>
                  </div>

                  <div className="emp-dashboard__kpi-grid">
                    <div className="emp-kpi-card">
                      <div>
                        <p className="emp-kpi-card__value">₹{formatCurrency(cash.cash_in_hand)}</p>
                        <p className="emp-kpi-card__label">Cash in hand</p>
                      </div>
                      <img src={inhand} alt="" className="emp-kpi-card__icon" />
                    </div>

                    <div className="emp-kpi-card emp-kpi-card--bank">
                      <div>
                        <p className="emp-kpi-card__value">₹{formatCurrency(cash.cash_in_bank)}</p>
                        <p className="emp-kpi-card__label">Cash at bank</p>
                      </div>
                      <img
                        onClick={handleBankDetails}
                        src={store}
                        alt="View bank breakdown"
                        className="emp-kpi-card__icon emp-kpi-card__icon--clickable"
                        data-tip="Bank details (click)"
                      />
                      <ReactTooltip backgroundColor="white" textColor="black" />
                    </div>

                    <div className="emp-kpi-card emp-kpi-card--total">
                      <div>
                        <p className="emp-kpi-card__value">₹{formatCurrency(cash.total_cash)}</p>
                        <p className="emp-kpi-card__label">Total cash available</p>
                      </div>
                      <img src={money} alt="" className="emp-kpi-card__icon" />
                    </div>

                    <div className="emp-kpi-card emp-kpi-card--dealer">
                      <div>
                        <p className="emp-kpi-card__value">₹{formatCurrency(dealer_statement.total_outstnd || 0)}</p>
                        <span className={`emp-kpi-card__badge ${(dealer_statement.total_outstnd || 0) > 0 ? "emp-kpi-card__badge--debit" : "emp-kpi-card__badge--credit"}`}>
                          {(dealer_statement.total_outstnd || 0) > 0 ? "Debit" : "Credit"}
                        </span>
                        <p className="emp-kpi-card__label">Dealer outstanding</p>
                      </div>
                      <img src={money} alt="" className="emp-kpi-card__icon" />
                    </div>
                  </div>

                  <div className="emp-dashboard__trends-grid">
                    <div className="emp-dashboard__panel emp-dashboard__sales-trend-panel">
                      <p className="emp-dashboard__panel-title">Sales trend</p>
                      <p className="emp-dashboard__panel-hint">
                        Daily fuel sales by product from nozzle closing readings (last 30 days).
                      </p>
                      <EmployeeSalesTrendChart
                        data={graph}
                        fuels={graph_details}
                        rangeDays={salesTrendRange}
                        onRangeChange={setSalesTrendRange}
                        variant="sales"
                      />
                    </div>

                    <div className="emp-dashboard__panel emp-dashboard__sales-trend-panel">
                      <p className="emp-dashboard__panel-title">Purchase trend</p>
                      <p className="emp-dashboard__panel-hint">
                        Daily fuel purchases from approved unloading invoices (last 30 days).
                      </p>
                      <EmployeeSalesTrendChart
                        data={purchaseGraph}
                        fuels={purchaseGraphDetails}
                        rangeDays={purchaseTrendRange}
                        onRangeChange={setPurchaseTrendRange}
                        variant="purchase"
                      />
                    </div>
                  </div>

                  <div className="emp-dashboard__main-grid">
                    <div className="emp-dashboard__panel">
                      <p className="emp-dashboard__panel-title">Total sales (litres)</p>
                      <p className="emp-dashboard__panel-hint">Fuel and non-fuel quantities for the selected period.</p>
                      <p className="emp-dashboard__period">{salesPeriodLabel}</p>

                      {!open ? (
                        <>
                          <div className="emp-dashboard__date-row">
                            <div className="emp-dashboard__date-field">
                              <label>Start date</label>
                              <input readOnly type="text" value={datestart} onClick={toggledate} placeholder="DD-MM-YYYY" />
                            </div>
                            <div className="emp-dashboard__date-field">
                              <label>End date</label>
                              <input readOnly type="text" value={dateend} onClick={toggledate} placeholder="DD-MM-YYYY" />
                            </div>
                          </div>

                          <div className="emp-dashboard__table-wrap">
                            <table className="table table-sm mb-0">
                              <thead>
                                <tr>
                                  <th>Fuel type</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(total_fuelsales?.fueldatas || []).map((obj, index) =>
                                  Number(obj.base_amt || 0) > 0 || Number(obj.recoup_amt || 0) > 0 || Number(obj.amt || 0) !== 0 ? (
                                    <tr key={`fuel-total-${obj.fuel_id || obj.fuel_name || index}`}>
                                      <td><FuelLabel name={obj.fuel_name} /></td>
                                      <td className={getFuelLabelClass(obj.fuel_name)}>
                                        {Number(obj.recoup_amt || 0) > 0
                                          ? `${formatLitres(obj.base_amt)} − ${formatLitres(obj.recoup_amt)} = ${formatLitres(obj.amt)}`
                                          : formatLitres(obj.amt)}
                                      </td>
                                    </tr>
                                  ) : null
                                )}
                                {(total_fuelsales?.fueldatas || []).filter((o) =>
                                  Number(o.base_amt || 0) > 0 || Number(o.recoup_amt || 0) > 0 || Number(o.amt || 0) !== 0
                                ).length === 0 ? (
                                  <tr><td colSpan="2" className="text-muted">No fuel sales in this period</td></tr>
                                ) : null}
                              </tbody>
                              <thead>
                                <tr>
                                  <th>Non-fuel product</th>
                                  <th>Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(total_nonfuelsales?.nonfueldata || []).map((obj, idx) =>
                                  obj.amt > 0 ? (
                                    <tr key={`nf-${obj.product_full_name || idx}`}>
                                      <td>{obj.product_full_name}</td>
                                      <td>{Number(obj.amt).toFixed(2)}</td>
                                    </tr>
                                  ) : null
                                )}
                                <tr>
                                  <td><strong>Total non-fuel</strong></td>
                                  <td><strong>{nonFuelTotal.toFixed(2)}</strong></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      ) : null}

                      <div style={{ width: "100%", maxWidth: 690 }}>
                        {open ? (
                          <DateRangePicker open={open} toggle={toggledate} onChange={(date) => setDateRange(date)} />
                        ) : null}
                      </div>
                    </div>

                    <div className="emp-dashboard__panel emp-dashboard__fuel-panel">
                      <p className="emp-dashboard__panel-title">Fuel stock levels</p>
                      <p className="emp-dashboard__panel-hint">Click a ring to view tank-wise breakdown.</p>
                      <div className="emp-dashboard__fuel-grid">
                        {(fuel_data || []).map((obj, index) => (
                          <FuelStockChart
                            key={`fuel-card-${obj.id || obj.fuel_id || index}`}
                            fuel={obj}
                            onSelect={handleFuelDetails}
                            formatLitres={formatLitres}
                          />
                        ))}
                        {(fuel_data || []).length === 0 ? (
                          <p className="emp-dashboard__empty">No active fuel products configured.</p>
                        ) : null}
                      </div>
                    </div>

                    <div className="emp-dashboard__panel emp-dashboard__reports-panel">
                      <p className="emp-dashboard__panel-title">Quick reports</p>
                      <p className="emp-dashboard__panel-hint">
                        Each report has a unique color — easy to spot when guiding over a call.
                      </p>
                      <div className="emp-dashboard__actions">
                        <Link
                          to="/op-simplified-balance-sheet"
                          className="btn emp-quick-report-btn emp-quick-report-btn--balance w-100"
                          aria-label="Balance sheet — teal button"
                        >
                          Balance sheet <i className="fa fa-long-arrow-right float-end" aria-hidden="true" />
                        </Link>
                        <Link
                          className="btn emp-quick-report-btn emp-quick-report-btn--pnl w-100"
                          to="/trade-profit-loss"
                          aria-label="Trade profit and loss — blue button"
                        >
                          Trade profit &amp; loss <i className="fa fa-long-arrow-right float-end" aria-hidden="true" />
                        </Link>
                        <Link
                          className="btn emp-quick-report-btn emp-quick-report-btn--daily w-100"
                          to="/daily-transaction-sheet"
                          aria-label="Daily transaction report — purple button"
                        >
                          Daily transaction report <i className="fa fa-long-arrow-right float-end" aria-hidden="true" />
                        </Link>
                        <Link
                          to="/op-dsr-report"
                          className="btn emp-quick-report-btn emp-quick-report-btn--dsr w-100"
                          aria-label="DSR report — orange button"
                        >
                          DSR report <i className="fa fa-long-arrow-right float-end" aria-hidden="true" />
                        </Link>
                        <Link
                          to="/day-closing"
                          className="btn emp-quick-report-btn emp-quick-report-btn--closing w-100"
                          aria-label="Day closing — rose button"
                        >
                          Day closing
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="emp-dashboard__secondary-grid">
                    <div hidden className="emp-dashboard__col-4">

<div className="emp-dashboard__panel">
 {/* <p><strong>EXPENSES</strong></p> */}
     <div className="row">
      {!open1
      ?
      <><div className="col-md-6">
     <p><strong>Start Date</strong></p>
     <p><strong><input style={{width:"110px"}} readOnly type="text" value={datestartexp} onClick={toggledateexp} placeholder="DD/MM/YYYY"></input></strong></p>
     
     </div>
     <div className="col-md-6">
     <p><strong>End Date</strong></p>
      <input style={{width:"110px"}} readOnly type="text" value={dateendexp} onClick={toggledateexp} placeholder="DD/MM/YYYY"></input>

     </div>

     <p><strong>Total Expenses</strong></p>
          {/* <div className="input-container">
             <input
             type="date"
             value={selectedDate}
             onChange={handleDateChange}
              className="date-input"
             />
          </div> */}
        
          <div className="table-widget">
     
          <table className="table border">
            <thead>
              <tr>
                <th style={{ ...thStyle }}><p><strong>Account Head</strong></p></th>
                <th style={{ ...thStyle }}><p><strong>DR</strong></p></th>
                <th style={{ ...thStyle }}><p><strong>CR</strong></p></th>
                <th style={{ ...thStyle }}><p><strong>Transaction Type</strong></p></th>
              </tr>
            </thead>
            <tbody>
               {(total_expenses || []).map(obj => (
                <tr>
                <td>{obj.accounts_head}</td>
            
            {obj.debit_credit === "Dr" ? (
                <td>{obj.amount}</td>
            ) : (
                <td>0</td>
            )}
            {obj.debit_credit === "Cr" ? (
                <td>{obj.amount}</td>
            ) : (
                <td>0</td>
            )}
                <td>{obj.particulars}</td>
                  </tr>
                                ))}

                              </tbody>
          </table>
          </div>
     </> 
     :""}
     

      
     </div>
      
     <div style={{width:"690px"}}>
     {open1 ? (
     <DateRangePicker
     open={open1}
     toggle={toggledateexp}
    //  minDate={total_fuelsales?.mindate? total_fuelsales?.mindate : null}
     onChange={(date) => setDateRangeexp(date)}
     />
     ) : null}
     </div>
     


          </div>
 
                   </div>

                    <div className="emp-dashboard__col-4">
                      <div className="emp-dashboard__panel">
                        <p className="emp-dashboard__panel-title">Gas cylinder stock</p>
                        <p className="emp-dashboard__panel-hint">Full and empty cylinders on hand.</p>
                        <div className="emp-dashboard__table-wrap">
                          <table className="table table-sm mb-0">
                            <thead>
                              <tr>
                                <th>Product</th>
                                <th>Full</th>
                                <th>Empty</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(total_cylinder || []).map((objj, idx) => (
                                <tr key={`cyl-${objj.product_name || idx}`}>
                                  <td>{objj.product_name}</td>
                                  <td>{objj.no_of_full_cylinder || 0}</td>
                                  <td>{objj.no_of_empty_cylinder || 0}</td>
                                </tr>
                              ))}
                              {(total_cylinder || []).length === 0 ? (
                                <tr><td colSpan="3" className="text-muted">No cylinder products</td></tr>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="emp-dashboard__col-4">
                      <div className="emp-dashboard__panel">
                        <p className="emp-dashboard__panel-title">Credit customers</p>
                        <p className="emp-dashboard__panel-hint">
                          Top outstanding balances with ageing and overdue status
                          {creditSummary.as_of_date ? ` (as of ${creditSummary.as_of_date})` : ""}.
                        </p>

                        <div className="emp-dashboard__credit-stats mb-2">
                          <div className="emp-dashboard__credit-stat">
                            <span className="emp-dashboard__credit-stat-label">Total outstanding</span>
                            <strong>₹{formatCurrency(creditStats.total_outstanding)}</strong>
                          </div>
                          <div className="emp-dashboard__credit-stat">
                            <span className="emp-dashboard__credit-stat-label">Overdue</span>
                            <strong className="text-danger">
                              ₹{formatCurrency(creditStats.total_overdue_amount)} ({creditStats.overdue_customer_count || 0})
                            </strong>
                          </div>
                        </div>

                        <div className="emp-dashboard__table-wrap">
                          <table className="table table-sm mb-0">
                            <thead>
                              <tr>
                                <th>Customer</th>
                                <th>Outstanding</th>
                                <th>Age</th>
                                <th>Overdue</th>
                              </tr>
                            </thead>
                            <tbody>
                              {topCreditCustomers.map((row) => (
                                <tr key={`credit-${row.head_id || row.customer_id}`}>
                                  <td>
                                    {row.head_id && id ? (
                                      <Link
                                        to={`/statement-of-account/${row.head_id}`}
                                        className="emp-dashboard__credit-link"
                                      >
                                        {row.customer_name}
                                      </Link>
                                    ) : (
                                      row.customer_name
                                    )}
                                    <div className="emp-dashboard__credit-period">{row.credit_period}</div>
                                  </td>
                                  <td>₹{formatCurrency(row.outstanding)}</td>
                                  <td>{row.oldest_unpaid_days || 0}d</td>
                                  <td>
                                    {row.is_overdue ? (
                                      <span className="emp-dashboard__overdue-badge">
                                        {row.days_overdue || 0}d · ₹{formatCurrency(row.overdue_amount)}
                                      </span>
                                    ) : (
                                      <span className="text-muted">—</span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                              {topCreditCustomers.length === 0 ? (
                                <tr>
                                  <td colSpan="4" className="text-muted">
                                    No customer outstanding balances found
                                  </td>
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="emp-dashboard__col-4">
                      <div className="emp-dashboard__panel">
                        <p className="emp-dashboard__panel-title">Critical non-fuel stock</p>
                        <p className="emp-dashboard__panel-hint">Products below lead-time cover — reorder soon.</p>
                        <div className="emp-dashboard__table-wrap">
                          <table className="table table-sm mb-0">
                            <thead>
                              <tr>
                                <th>Product</th>
                                <th>Stock</th>
                                <th>Days left</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(critical_stock || []).map((obj, index) => (
                                <tr key={`critical-${obj.id || obj.product_id || index}`}>
                                  <td>{obj.product_name}</td>
                                  <td>{obj.total_stock}</td>
                                  <td>{obj.fuel_available_days ?? "—"}</td>
                                </tr>
                              ))}
                              {(critical_stock || []).length === 0 ? (
                                <tr><td colSpan="3" className="text-muted">All non-fuel stock levels are healthy</td></tr>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="emp-dashboard__col-12">
                      <div className="emp-dashboard__panel emp-dashboard__price-trend-panel">
                        <p className="emp-dashboard__panel-title">Fuel price trend</p>
                        <p className="emp-dashboard__panel-hint">
                          Compare sales price and purchase price per litre over time.
                        </p>
                        <EmployeeFuelPriceTrendChart
                          data={fuelPriceTrendData}
                          series={fuelPriceTrendSeries}
                          filter={priceTrendFilter}
                          onFilterChange={setPriceTrendFilter}
                          loading={priceTrendLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
}
            </div>
          </div>
        </div>
      </div>
      <FuelDetailModal
        isOpen={isOpen}
        onClose={toggleModal}
        fueldata={fueldata}
      />

      <BankModal
        isOpen={isOpen1}
        onRequestClose={toggleModal1}
        contentLabel="Bank details"
        className="mymodal custommodal"
        overlayClassName="myoverlay"
        shouldCloseOnOverlayClick
        style={{
          overlay: { zIndex: 10050 },
          content: { zIndex: 10051 },
        }}
      >

<div className="modal-content">
          <div className="modal-title modal-header"><h5 className="modal-title" id="exampleModalLongTitle1">Bank Details</h5><button type="button" onClick={toggleModal1} className="btn-close" data-dismiss="modal" aria-label="Close"></button></div>
          <div className=" modal-body  modal-body">

          </div>
          <div className="table-widget">
            <table className="table border">
              <thead>
                <tr>
                  <th>Tank Name</th>
                  <th>Capacity</th>
                  <th>Current Stock </th>


                </tr>
              </thead>
              <tbody>
                {/* {
                  (fueldata || []).map(obj => (
                    <tr>
                      <td>{obj.tank_name}</td>
                      <td>{obj.capacity}</td>
                      <td>{obj.current_stock}</td>


                    </tr>
                  ))
                } */}
              </tbody>
            </table>
          </div>

        </div>

      </BankModal>

      {isClose ? (<TankModal
        isClose={isClose}
        hide={toggle}
        tankdata={tankdata}
        Bank_data={Bank_data}
      />) : null
      }




    </>
  )
}


export default DashBoard;

